/*
 * main
 */
import "./i18n"
import { createRouter, RouterProvider } from "@tanstack/react-router"
import { toast } from "@emr/react-ui"
import { isProd } from "@emr/utils"
import { StrictMode } from "react"
import ReactDOM from "react-dom/client"
import { registerSW } from "virtual:pwa-register"
import { routeTree } from "./routeTree.gen"

const router = createRouter({ routeTree })

declare module "@tanstack/react-router" {
	interface Register {
		router: typeof router
	}
}

const rootElement = document.getElementById("root")!
if (!rootElement.innerHTML) {
	const root = ReactDOM.createRoot(rootElement)
	root.render(
		<StrictMode>
			<RouterProvider router={router} />
		</StrictMode>,
	)
}

if ("serviceWorker" in navigator && !/localhost/.test(window.location.host)) {
	console.debug("Registering service worker")
	const updateSW = registerSW({
		onRegistered: () => {
			console.debug("Service worker registered")
			if (!isProd) {
				toast("Service worker registered")
			}
		},
		onRegisterError: (error: any) => {
			console.error("Service worker registration error", error)
			if (!isProd) {
				toast("Service worker registration error")
			}
		},
		onOfflineReady: () => {
			console.debug("App is offline-ready")
			if (!isProd) {
				toast("App is offline-ready")
			}
		},
		onNeedRefresh: () => {
			console.debug("Service worker needs to be refreshed")
			if (!isProd) {
				toast("Service worker needs to be refreshed")
			}
			updateSW.update()
		},
	})
}
